import ButtonMenu from "componentsv2/menu/ButtonMenu";
import { ArcheryIcon } from "components/Icons";

function MenuActions({ actions, record }) {
  return (
    <ButtonMenu
      title="Actions"
      type="action"
      record={record}
      values={actions}
      Icon={ArcheryIcon}
    />
  );
}

export default MenuActions;
